import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { NAV } from "@/constants/testIds";
import { INTAKE_URL } from "@/constants/links";

const LOGO =
  "https://customer-assets.emergentagent.com/job_integrated-wellness-6/artifacts/amgkh1mp_logo.png";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === "/";

  const links = [
    { href: onHome ? "#tracks" : "/#tracks", label: "Programs", id: NAV.linkTracks },
    { href: onHome ? "#matrix-engine" : "/#matrix-engine", label: "The Tech", id: "nav-link-matrix" },
    { href: onHome ? "#methodology" : "/#methodology", label: "How It Works", id: NAV.linkMethodology },
    { href: onHome ? "#faq" : "/#faq", label: "FAQ", id: NAV.linkFaq },
  ];

  return (
    <header
      data-testid={NAV.root}
      className="sticky top-0 z-40 border-b border-[color:var(--iw-border)] bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/70"
    >
      <div className="mx-auto flex max-w-7xl items-center gap-6 px-5 py-4 sm:px-8 lg:gap-10">
        <Link to="/" data-testid={NAV.logo} className="group flex flex-shrink-0 items-center gap-4">
          <img
            src={LOGO}
            alt="Integrated Wellness logo"
            className="h-16 w-16 rounded-full object-cover ring-1 ring-[color:var(--iw-border)] sm:h-20 sm:w-20"
            decoding="async"
            loading="eager"
            width="80"
            height="80"
          />
          <div className="leading-tight">
            <div className="font-display text-[22px] font-semibold tracking-tight text-[color:var(--iw-primary)] sm:text-[26px] lg:text-[28px]">
              Integrated Wellness
            </div>
          </div>
        </Link>

        <nav className="hidden flex-1 items-center justify-evenly md:flex">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={l.id}
              className="font-mono text-[13px] uppercase tracking-[0.18em] text-[color:var(--iw-primary)] hover:text-[color:var(--iw-accent-red)] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden flex-shrink-0 items-center gap-4 md:flex">
          <a
            href={INTAKE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={NAV.ctaApply}
            className="iw-btn-red inline-flex items-center gap-2 px-5 py-3 font-mono text-[12px] uppercase tracking-[0.18em]"
          >
            Get Started <ArrowUpRight className="h-3.5 w-3.5" />
          </a>
        </div>

        <button
          type="button"
          data-testid={NAV.mobileToggle}
          onClick={() => setOpen((v) => !v)}
          className="grid h-10 w-10 place-items-center border border-[color:var(--iw-border)] text-[color:var(--iw-primary)] md:hidden"
          aria-label="Toggle navigation"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-[color:var(--iw-border)] bg-white md:hidden">
          <div className="flex flex-col px-5 py-4">
            {links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                data-testid={`${l.id}-mobile`}
                onClick={() => setOpen(false)}
                className="border-b border-[color:var(--iw-border)] py-3 font-mono text-sm uppercase tracking-[0.2em] text-[color:var(--iw-primary)]"
              >
                {l.label}
              </a>
            ))}
            <a
              href={INTAKE_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              data-testid={`${NAV.ctaApply}-mobile`}
              className="iw-btn-red mt-4 inline-flex items-center justify-center gap-2 px-5 py-3 font-mono text-[12px] uppercase tracking-[0.2em]"
            >
              Get Started <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
